import type {
    FruitSliceFrame,
    FruitSliceMeta,
    FruitSliceWithAccess,
} from '@fruitful/types';
import { useQuery } from '@tanstack/react-query';

import { fetcher } from '../../http/Fetcher';

const FRUIT_SLICES_PATH = '/api/admin/fruit-slices';
const FRUIT_SLICES_QUERY_KEY = 'fruitSlices';

export const useListFruitSlices = () => {
    return useQuery<FruitSliceMeta[], Error>({
        queryKey: [FRUIT_SLICES_QUERY_KEY],
        queryFn: async () =>
            await fetcher<FruitSliceMeta[]>({ endpoint: FRUIT_SLICES_PATH }),
    });
};

export const useGetFruitSlice = (id: string) => {
    return useQuery<FruitSliceWithAccess, Error>({
        queryKey: [FRUIT_SLICES_QUERY_KEY, id],
        queryFn: async () =>
            await fetcher<FruitSliceWithAccess>({
                endpoint: `${FRUIT_SLICES_PATH}/${encodeURIComponent(id)}`,
            }),
        enabled: id.length > 0,
    });
};

export const useListFruitSliceFrames = (fruitSliceId: string) => {
    return useQuery<FruitSliceFrame[], Error>({
        queryKey: [FRUIT_SLICES_QUERY_KEY, fruitSliceId, 'frames'],
        queryFn: async () =>
            await fetcher<FruitSliceFrame[]>({
                endpoint: `${FRUIT_SLICES_PATH}/${encodeURIComponent(
                    fruitSliceId,
                )}/frames`,
            }),
        enabled: fruitSliceId.length > 0,
    });
};

export const useGetFruitSliceFrame = (
    fruitSliceId: string,
    frameId: string,
) => {
    return useQuery<FruitSliceFrame, Error>({
        queryKey: [FRUIT_SLICES_QUERY_KEY, fruitSliceId, 'frames', frameId],
        queryFn: async () =>
            await fetcher<FruitSliceFrame>({
                endpoint: `${FRUIT_SLICES_PATH}/${encodeURIComponent(
                    fruitSliceId,
                )}/frames/${encodeURIComponent(frameId)}`,
            }),
        enabled: fruitSliceId.length > 0 && frameId.length > 0,
    });
};
